"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SponsorBadge = SponsorBadge;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _icons = require("./icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function SponsorBadge({
  size
}) {
  return /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: "Cette entreprise est engag\xE9e ! Sa souscription au challenge permet le financement des actions Team for the Planet"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#eee8fd",
    borderRadius: 2,
    display: "flex",
    gap: 0.5,
    paddingX: 1,
    paddingY: 0.5
  }, /*#__PURE__*/_react.default.createElement(_icons.SponsorIcon, {
    sx: size === 'small' ? {
      height: 14,
      width: 14
    } : {}
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "#6236bd",
    lineHeight: "14px",
    variant: size === 'small' ? 'caption' : 'body2'
  }, "Sponsor")));
}